// #ux-redesign-start: Main2fa migra SweetAlert input → Modal DS con Input
// El SweetAlert tenía un `input password` para confirmar deactivation;
// aquí lo reemplazamos por un Modal DS con campo controlado.
// ─────────────────────────────────────────────────────────────────────────────

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from 'react-translate';
import {
  Row,
  Col,
  FormGroup,
  CustomInput,
} from 'reactstrap';

import {
  actionCreate2fa,
  actionInactivate2fa,
} from 'store/actions/usersActions';
import Form2fa from './Form2fa';

import { Modal, Button, Input } from 'components/ds';

const Main2fa = (props) => {
  const { t } = props;
  const user = useSelector((state) => state.userReducer);
  const [showForm, setShowForm] = useState(false);
  const [switchChecked, setSwitchChecked] = useState(user.auth_2fa === true);

  // #ux-redesign: confirm dialog para deactivar 2FA (con password input)
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();

  const handleChange = () => {
    const next = !switchChecked;
    setSwitchChecked(next);
    if (next && !user.auth_2fa) {
      dispatch(actionCreate2fa());
      setShowForm(true);
    } else {
      setShowForm(false);
      if (user.auth_2fa === true) {
        setConfirmOpen(true);
      }
    }
  };

  const handleConfirm = () => {
    dispatch(actionInactivate2fa(password));
    setConfirmOpen(false);
    setPassword('');
  };

  const handleCancel = () => {
    setSwitchChecked(true);
    setConfirmOpen(false);
    setPassword('');
  };

  return (
    <div className="setting-section">
      <h5 className="general-card-subtitle">{t('title')}</h5>
      <Row>
        <Col md="12">
          <FormGroup>
            <CustomInput
              type="switch"
              id="auth2fa_switch"
              className="custom-switch-settings"
              label=""
              checked={switchChecked}
              onChange={handleChange}
              inline
            />
            <label>{t('activate')}</label>
          </FormGroup>
        </Col>
        <Col md="12">
          {user.uri && showForm && (
            <Form2fa
              setShowForm={setShowForm}
              setSwitchChecked={setSwitchChecked}
            />
          )}
        </Col>
      </Row>

      <Modal
        isOpen={confirmOpen}
        onClose={handleCancel}
        title={t('are-you-sure')}
        size="sm"
      >
        <p>{t('disable')}</p>
        <Input
          type="password"
          placeholder={t('password-placeholder')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 'var(--space-2)',
            marginTop: 'var(--space-4)',
          }}
        >
          <Button variant="secondary" onClick={handleCancel}>
            {t('btn-no')}
          </Button>
          <Button variant="danger" onClick={handleConfirm} disabled={!password}>
            {t('btn-yes')}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default translate('2fa')(Main2fa);
// #ux-redesign-end
